import React from 'react';
import { Layout } from 'components/ds';
import styled, { createGlobalStyle } from 'styled-components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ResponsiveWidth } from 'components/Css';
import FilteredModules from '../../../shared/FilteredModules';

const { Content } = Layout;

const GlobalStyle = createGlobalStyle`
  body, html {
    background: var(--color-background-light) !important;
  }
`;

const Provider = styled(DndProvider)`
  .mobileViewer & {
    zoom: 0.5;
    width: 400px;
  }
`;

const Container = styled(Content)`
  margin: 0 auto;  
  max-width: 1260px;
  width: 100%;
  padding-bottom: 80px;
`;

const BarRadius = styled.div`
  @media (max-width: ${ResponsiveWidth}px) {
    height: var(--borderRadiusBase);
    border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0px 0px;
    margin-top: calc(-1 * var(--borderRadiusBase));
    background-color: var(--colorBgBase);
  }
`;

const PageTemplate = () => (
    <>
      <GlobalStyle />
      <Provider backend={HTML5Backend}>
        <Layout>
          <FilteredModules componentName="header" />
          <BarRadius />
          <Container>
            <FilteredModules componentName="content" />
          </Container>
          <FilteredModules componentName="footer" />
        </Layout>
      </Provider>
    </>
  );

export default PageTemplate;
